export class ActionQuery {
    constructor(config, queryService, buildResult) {
        this.config = config;
        this.queryService = queryService;
        this.buildResult = buildResult;
    }
    /**
     * Sets action to use for request
     */
    withAction(action) {
        return this.buildResult(this.config, this.queryService, action);
    }
}
//# sourceMappingURL=action-query.class.js.map